import { Pipe, PipeTransform } from '@angular/core';

const regex = /(<img.*?src="(.*?)"[^\>]?>)/gm;

@Pipe({
    name: 'linkImages',
    standalone: true,
})
export class LinkImagesPipe implements PipeTransform {
    transform(value: string): any {
        return value.replace(regex, '<a href="$2" target="_blank">$1</a>');
    }
}
